/*eslint-disable*/
import { useSnackbar } from 'notistack';
import { useState } from 'react';
import { useTranslation, Trans } from 'react-i18next';
import {
  Box,
  Dialog,
  Button,
  Typography,
  makeStyles,
  Container,
} from '@material-ui/core';
import {color} from "@material-ui/system";

const NotificationForgotPassword = ({
  email,
  onClose,
  parentClose,
  open,
  ...rest
}) => {
  const { enqueueSnackbar } = useSnackbar();
  const [editor, setEditor] = useState<boolean>(true);
  const [view, setView] = useState<boolean>(false);
  const { t } = useTranslation('account');
  const isUser = email.includes('@');

  const handleAllClose = () => {
    onClose();
    parentClose();
  };

  return (
    <Dialog onClose={onClose} open={open} maxWidth="sm" fullWidth {...rest}>
      <Box
        sx={{
          backgroundColor: 'background.default',
          minHeight: '100%',
          p: 3,
        }}
      >
        <Container maxWidth="sm">
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
            }}
          >
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
              }}
              paddingBottom={5}
            >
              <Typography
                sx={{
                  fontSize: '24px',
                  color: '#001930',
                  fontWeight: 700,
                  lineHeight: '25px',
                }}
              >
                {`¡Listo!`}
              </Typography>
            </Box>
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
              }}
              paddingBottom={5}
            >
              <Typography
                sx={{
                  fontSize: '0.875',
                  color: '#42526E',
                  textAlign: 'center',
                }}
              >
                {isUser ? (
                  <Trans i18nKey="account.forgotPassword.notification">
                    Te enviamos un enlace para el restablecimiento de contraseña
                    a tu correo electrónico <strong>{{ email }}</strong>. Favor revísalo
                    para continuar con el proceso.
                  </Trans>
                ) : (
                  <Trans i18nKey="account.forgotPassword.notificationProvider">
                    Te enviamos un enlace para el restablecimiento de contraseña
                    a tu correo electrónico <strong>{{ email }}</strong>. Favor revísalo
                    para continuar con el proceso.
                  </Trans>
                )}
              </Typography>
            </Box>
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
              }}
              paddingBottom={5}
            >
              <Typography
                sx={{
                  fontSize: '0.875',
                  color: '#42526E',
                  textAlign: 'center',
                }}
              >
                <Trans i18nKey="account.forgotPassword.sendAgain">
                  ¿No recibiste el correo electrónico ? Mira en tu carpeta de
                  correo no deseado o{' '}
                  <strong>
                    <a onClick={onClose} color={'#FCBE00'}>vuelve a enviarlo.</a>
                  </strong>
                  .
                </Trans>
              </Typography>
            </Box>
          </Box>
          <Box
            sx={{
              display: 'flex',
              mt: 4,
              justifyContent: 'center',
            }}
          >
            <Button
              sx={{
                width: '50%',
                backgroundColor: '#FCBE00',
              }}
              size="large"
              variant="contained"
              onClick={handleAllClose}
            >
              Continuar
            </Button>
          </Box>
        </Container>
      </Box>
    </Dialog>
  );
};

export default NotificationForgotPassword;
